import { Badge, type Breakpoint, Stack, type Theme, useMediaQuery } from "@mui/material";
import { MenuPopover } from "@surfaces/MenuPopover";
import type { ReactNode } from "react";
import { CompactFilters } from "./compactFilters";

export enum ResponsiveFiltersDisplay {
  DASHBOARD = "dashboard",
  OTHER = "other",
}

export interface IResponsiveFiltersProps {
  filters: { label: string; content: ReactNode; badgeCount: number; onClose: () => void; onOpen: () => void }[];
  onReset: () => void;
  display?: ResponsiveFiltersDisplay;
  breakpoint?: Breakpoint;
}

export const ResponsiveFilters = ({
  filters,
  onReset,
  display = ResponsiveFiltersDisplay.DASHBOARD,
  breakpoint = "tablet",
}: IResponsiveFiltersProps) => {
  const breakpointReached = useMediaQuery((theme: Theme) => theme.breakpoints.up(breakpoint));

  return breakpointReached ? (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        width: "max-content",
      }}
    >
      {filters.map(({ label, badgeCount, content, ...props }) => (
        <Badge key={label} badgeContent={badgeCount} color="yellow">
          <MenuPopover label={label} {...props}>
            {content}
          </MenuPopover>
        </Badge>
      ))}
    </Stack>
  ) : (
    <CompactFilters filters={filters} onReset={onReset} display={display} breakpoint={breakpoint} />
  );
};
